export type Tone = "positive" | "negative" | "neutral";

export const toTone = (value: number): Tone => {
  if (value > 0) {
    return "positive";
  }
  if (value < 0) {
    return "negative";
  }
  return "neutral";
};

// Maps a tone to its themed CSS colour variable. Used by styled-components that
// colour text, bars, or strokes by gain/loss.
export const toneColor = (tone: Tone): string => {
  if (tone === "negative") {
    return "var(--color-error)";
  }
  if (tone === "positive") {
    return "var(--color-success)";
  }
  return "var(--color-text-default)";
};

export type AmountVariant = "income" | "expense" | "neutral";

// The money vocabulary read as a tone: an amount tinted in a row and the same
// amount in the dialog that acts on it must not drift to two scales.
export const amountVariantColor = (variant?: AmountVariant): string => {
  if (variant === "income") {
    return toneColor("positive");
  }
  if (variant === "expense") {
    return toneColor("negative");
  }
  return toneColor("neutral");
};
